var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561,
    height: 60,
    viewBox: "0 0 561 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.822 56V20.9902H466.312V26.9961H446.561V35.0527H463.309V41.0586H446.561V49.9941H466.824V56H439.822Z",
    fill: "#18191B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.981 20.9902H435.379L422.269 56H413.528L400.125 20.9902H407.669L418.045 48.9199L427.981 20.9902Z",
    fill: "#18191B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M389.09 56V20.9902H395.828V56H389.09Z",
    fill: "#18191B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353.006 56V20.9902H364.993C375.564 20.9414 382.815 27.2158 382.742 38.4951C382.815 49.7988 375.784 56.0732 365.262 56H353.006ZM359.744 49.9941H364.505C368.143 49.9941 370.975 49.1152 372.977 47.3574C375.003 45.5996 376.004 42.6455 376.004 38.4951C376.004 34.3691 375.003 31.415 372.977 29.6572C370.975 27.875 368.143 26.9961 364.505 26.9961H359.744V49.9941Z",
    fill: "#18191B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.729 56V26.9961H306.644V20.9902H337.649V26.9961H325.491V56H318.729Z",
    fill: "#18191B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.785 56V20.9902H303.274V26.9961H283.523V35.0527H300.271V41.0586H283.523V49.9941H303.787V56H276.785Z",
    fill: "#18191B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M264.358 56L253.812 40.5947L249.197 45.4531V56H242.459V20.9902H249.197V36.7129L264.065 20.9902H272.415L258.621 35.5166L272.708 56H264.358Z",
    fill: "#18191B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.23 56V20.9902H224.49C230.35 20.917 235.354 25.1162 235.232 30.5117C235.306 34.5888 232.229 38.1289 228.982 39.2031C231.351 39.3496 232.083 40.4482 232.938 43.207L236.99 56H229.983L226.736 45.6484C226.126 43.622 225.223 42.7431 223.538 42.7431H214.969V56H208.23ZM214.969 36.8593H222.488C226.419 36.8593 228.47 35.1015 228.47 31.8056C228.47 28.583 226.492 26.9961 222.488 26.9961H214.969V36.8593Z",
    fill: "#18191B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.683 56L193.533 47.748H178.836L175.687 56H168.582L182.425 20.9902H190.335L203.836 56H196.683ZM181.106 41.7422H191.238L186.16 28.4609L181.106 41.7422Z",
    fill: "#18191B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.909 20.9902H164.358V56H157.742V28.4609L149.051 56H141.653L132.693 28.3632V56H126.102V20.9902H136.6L145.389 48.456L153.909 20.9902Z",
    fill: "#18191B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3333C0 21.4924 1.49238 20 3.33333 20H36.6667C38.5076 20 40 21.4924 40 23.3333V56.6667C40 58.5076 38.5076 60 36.6667 60H3.33333C1.49238 60 0 58.5076 0 56.6667V23.3333Z",
    fill: "url(#paint0_linear_14307_39241)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33333C30 1.49239 31.4924 0 33.3333 0H86.6667C88.5076 0 90 1.49238 90 3.33333V56.6667C90 58.5076 88.5076 60 86.6667 60H33.3333C31.4924 60 30 58.5076 30 56.6667V3.33333Z",
    fill: "url(#paint1_linear_14307_39241)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33333C30 1.49239 31.4924 0 33.3333 0H86.6667C88.5076 0 90 1.49238 90 3.33333V56.6667C90 58.5076 88.5076 60 86.6667 60H33.3333C31.4924 60 30 58.5076 30 56.6667V3.33333Z",
    fill: "url(#paint2_linear_14307_39241)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33333C30 1.49238 31.4924 0 33.3333 0H60V10H30V3.33333Z",
    fill: "url(#paint3_linear_14307_39241)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33333C30 1.49238 31.4924 0 33.3333 0H60V10H30V3.33333Z",
    fill: "#FF0508",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 40,
    height: 10,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 40,
    height: 10,
    fill: "url(#paint4_linear_14307_39241)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 40,
    height: 10,
    fill: "#FF0508"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 20,
    height: 10,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 20,
    height: 10,
    fill: "url(#paint5_linear_14307_39241)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 20,
    height: 10,
    fill: "#FF0508",
    fillOpacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 50,
    height: 10,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 50,
    height: 10,
    fill: "url(#paint6_linear_14307_39241)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 50,
    height: 10,
    fill: "#FF0508",
    fillOpacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 40,
    height: 10,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 40,
    height: 10,
    fill: "url(#paint7_linear_14307_39241)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 40,
    height: 10,
    fill: "#FF0508",
    fillOpacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30 50H90V56.6667C90 58.5076 88.5076 60 86.6667 60H33.3333C31.4924 60 30 58.5076 30 56.6667V50Z",
    fill: "#D9D9D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30 50H90V56.6667C90 58.5076 88.5076 60 86.6667 60H33.3333C31.4924 60 30 58.5076 30 56.6667V50Z",
    fill: "url(#paint8_linear_14307_39241)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30 50H90V56.6667C90 58.5076 88.5076 60 86.6667 60H33.3333C31.4924 60 30 58.5076 30 56.6667V50Z",
    fill: "#FF0508"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 60H36.6667C38.5076 60 40 58.5076 40 56.6667V23.3333C40 21.4924 38.5076 20 36.6667 20H30V56.6667C30 58.5076 31.4924 60 33.3333 60Z",
    fill: "url(#paint9_linear_14307_39241)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M40 50H30V40H40V50Z",
    fill: "#FFC400"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30 20H36.6667C38.5076 20 40 21.4924 40 23.3333V30H30V20Z",
    fill: "#FFE300"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14307_39241",
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14307_39241",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14307_39241",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14307_39241",
    x1: 30,
    y1: 0,
    x2: 60,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14307_39241",
    x1: 30,
    y1: 10,
    x2: 70,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14307_39241",
    x1: 30,
    y1: 20,
    x2: 50,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14307_39241",
    x1: 30,
    y1: 30,
    x2: 80,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14307_39241",
    x1: 30,
    y1: 40,
    x2: 70,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14307_39241",
    x1: 30,
    y1: 50,
    x2: 90,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14307_39241",
    x1: 60,
    y1: 20,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.53eab1c823ea4318ec1dbb61e11cb45f.svg";
export { ForwardRef as ReactComponent };